module.exports = __webpack_public_path__ + "static/media/Tata.6bd2447b.svg";